import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Card, PageTitle, fmtDate } from "./shared";
import { MatchSettings } from "./MatchSettings";

const FIELDS = [
  ["conectr_url", "Sample ConectR presentation link", "https://…"],
  ["operator_name", "Operator name (footer)", "PropertiesforNRI.com"],
  ["contact_email", "Contact email (footer)", "hello@…"],
  ["business_hours", "Business hours (footer)", "Mon–Sat, 10:00–19:00 IST"],
];

export default function Settings() {
  const { data } = useQuery({ queryKey: ["staff-settings"], queryFn: () => api.get("/staff/settings").then((r) => r.data) });
  const { data: logs = [] } = useQuery({ queryKey: ["audit"], queryFn: () => api.get("/staff/audit").then((r) => r.data) });
  const [f, setF] = useState({});
  useEffect(() => data && setF(data), [data]);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/staff/settings", f);
      toast.success("Settings saved");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="space-y-5" data-testid="staff-settings-page">
      <PageTitle>Settings</PageTitle>
      <Card>
        <form onSubmit={save} className="space-y-4" data-testid="settings-form">
          {FIELDS.map(([k, label, ph]) => (
            <div key={k}>
              <label className="mb-1 block text-sm font-medium" htmlFor={`set-${k}`}>{label}</label>
              <input id={`set-${k}`} value={f[k] || ""} placeholder={ph} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-11 w-full rounded-xl border border-neutral-200 px-3 text-sm outline-none focus:border-[var(--saffron)]" data-testid={`settings-${k}-input`} />
            </div>
          ))}
          <button className="btn-saffron h-11 rounded-full px-6 text-sm font-semibold" data-testid="settings-save-button">Save settings</button>
        </form>
      </Card>
      <MatchSettings />
      <Card>
        <p className="mb-3 font-semibold">Recent staff activity</p>
        <ul className="max-h-80 divide-y divide-neutral-100 overflow-y-auto text-sm" data-testid="audit-log-list">
          {logs.map((l) => (
            <li key={l.id} className="flex flex-wrap justify-between gap-2 py-2">
              <span><b className="font-medium">{l.user_email}</b> · {l.action.replace(/_/g, " ")}</span>
              <span className="text-xs text-neutral-500">{fmtDate(l.created_at)}</span>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
